module.exports = "https://cdn.hellotech.com/client-assets/garage_doors_mobile_bd44ecc303db78e297d850ad9302e259.png";